import { Typography } from '@mui/material';
import React from 'react';
export var YoutubeEmbed = function (_a) {
    var embedId = _a.embedId;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "h4", sx: {
                textAlign: 'center',
                mb: 2,
                pt: 2,
            } }, "\u041A\u0430\u043A \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435"),
        React.createElement("iframe", { src: "https://www.youtube.com/embed/".concat(embedId), frameBorder: "20", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, title: "Embedded youtube" })));
};
